import React from 'react';
import { Box, Typography } from '@mui/material';

export interface WidgetLoaderProps {
  widgetType?: string;
}

export default function WidgetLoader(props: WidgetLoaderProps): JSX.Element {
  return (
    <Box sx={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <Box>
      {props.widgetType &&
        <Typography variant="body2" color="textSecondary" sx={{ textAlign: "center", opacity: 0.7, pb: 2 }}>
          {props.widgetType}
        </Typography>
      }
      <img src='/img/Infegy_Logo_Loader.svg' alt='Loading...' style={{ width: '100%', height: '100%', maxWidth: '100px', opacity: 0.3 }} />
      </Box>
    </Box>
  );
}